import { SummarizerConfig } from '../../types/summarizer';
// Import custom component (we'll create it next)
// import VideoInputWithPreview from '../../components/summarizer/custom/VideoInputWithPreview';

export const videoSummarizerConfig: SummarizerConfig = {
  // Basic identification
  id: 'video-summarizer',
  title: 'Video File Summarizer',
  description: 'Upload and summarize any video file with AI-powered analysis',
  version: '1.0.0',

  // Categorization
  category: 'video',
  tags: ['video', 'mp4', 'avi', 'mov', 'upload'],

  // Input configuration
  inputs: {
    file: {
      enabled: true,
      acceptedTypes: ['.mp4', '.mov', '.mkv', '.webm'],
      maxSize: 500 * 1024 * 1024, // 500MB in bytes
      placeholder: 'Upload your video file',
      multiple: false,
      helpText:
        'Upload video files up to 500MB. Get AI-powered summaries with key moments and insights.',
      showHelpText: true,
    },
    url: {
      enabled: true,
      placeholder: 'Or enter direct video URL',
      // validation: /\.(mp4|avi|mov|mkv|webm)$/i,
      examples: ['https://example.com/video.mp4', 'https://cdn.example.com/presentation.mov'],
      helpText: 'Provide a direct URL to a video file for instant processing.',
      showExamples: true,
      showHelpText: true,
    },
  },

  // Output features
  outputs: {
    summary: true,
    chat: true,
    mindmap: true,
    translation: true,
    keyPoints: true,
    transcript: true,
    download: true,
    share: true,
  },

  // Backend integration
  api: {
    endpoint: '/summarize',
    method: 'POST',
    contentType: 'video',
    timeout: 120000, // 2 minutes for video processing
  },

  // UI customization (Level 3: Custom component example)
  ui: {
    // Basic styling
    primaryColor: '#8b5cf6',
    secondaryColor: '#7c3aed',
    icon: '🎬',

    // Custom loading messages for video file content
    loadingMessages: {
      aiGeneration: {
        title: 'AI is processing your video file...',
        subtitle:
          'Analyzing video content, extracting audio, and generating comprehensive insights.',
      },
      translation: {
        title: 'Translating video summary to {language}...',
        subtitle: 'Converting your video summary to the selected language.',
      },
      streaming: {
        indicator: 'Processing video content...',
      },
    },

    // Custom styles (Level 2)
    customStyles: {
      container: '',
      inputArea: 'bg-white shadow-md',
      button: 'bg-purple-600 hover:bg-purple-700 shadow-lg',
    },

    // Custom components (Level 3) - commented out for now
    customComponents: {
      // input: VideoInputWithPreview, // Custom video preview component
      input: undefined, // Use default for now
      output: undefined,
      layout: undefined,
    },

    theme: 'light',
  },

  // Validation rules
  validation: {
    required: true,
    minSize: 1 * 1024 * 1024, // 1MB minimum
    maxSize: 500 * 1024 * 1024, // 500MB in bytes
    allowedDomains: [],
    blockedDomains: [],
  },

  // Feature flags
  features: {
    beta: false,
    premium: false,
    experimental: false,
  },

  // Metadata
  author: 'TubeOnAI',
  createdAt: '2024-01-01',
  updatedAt: '2024-01-01',
};
